import { Component, Input, OnInit } from '@angular/core';
import { BrowseComponent } from '@shared/components/browse/abstract.browse.component';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowseConfig } from '@core/bean/browse-config';
import { AsnService } from '../../../../routes/jy-srm/asn/asn.service';


/**
 * 用户浏览按钮
 */
@Component({
  selector: 'asn-browse',
  templateUrl: './asn.browse.component.html',
})
export class AsnBrowseComponent implements BrowseComponent, OnInit {

  static componentName = 'AsnBrowseComponent';

  @Input() config: BrowseConfig;
  @Input() onOk: (data: any | [any]) => void;
  @Input() onCancel: () => void;

  visible = false;
  pagination: Pagination = new Pagination();

  constructor(
    private commonsService: CommonsService,
    private modalService: NzModalService,
    private asnService: AsnService,
  ) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return asnService.query(params);
    };
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.pagination.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }


  selectData(data) {
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage('commons.info.selectData');
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }
}
